import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


//import '@/styles/globals.css'

//import '@/styles/styles.css'


import './styles/globals.css'
import './styles/styles.css'


import 'bootstrap/dist/css/bootstrap.min.css';
//import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import "draft-js/dist/Draft.css";


//import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import './entry/Candidates.css'
import './UserElements/IndustriesAreas.css'
import './entry/UserRecruiter.css'
import './entry/Login.css'
import './entry/PostVacancy2.css'





const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
